import { APP } from "@constants/app.constants";
const { STATUS, EMAIL_TEMPLATE_TYPE } = APP;

export const getEmailTemplateFormInputs = ({
  initialValues,
  handleFileUpload,
}) => [
  {
    type: "TEXT",
    label: "Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the name",
    validations: [
      {
        type: "REQUIRED",
        message: "Name is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Email Content",
    id: "emailContent",
    name: "email_content",
    value: initialValues?.emailContent || "",
    placeholder: "Enter the Content",
    validations: [],
  },
  {
    type: "SELECT",
    label: "Default",
    id: "isDefault",
    name: "is_default",
    options: EMAIL_TEMPLATE_TYPE,
    value: initialValues?.isDefault || 1,
    placeholder: "Select template type",
    validations: [
      {
        type: "REQUIRED",
        message: "EMail type is required !",
      },
    ],
  },

  {
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: STATUS,
    value: initialValues?.status || 1,
    placeholder: "Select Status",
    validations: [
      {
        type: "REQUIRED",
        message: "Status is required !",
      },
    ],
  },

  {
    groupName: "File Upload",
    hideGroupName: true,
    type: "FILE_UPLOAD",
    name: "file",
    id: "file",
    label: "File Upload",
    loading: false,
    multipleUpload: false,
    value: initialValues?.file || "",
    handleUpload: handleFileUpload,
    validations: [],
  },
];
